import React from 'react'

export default function PDIR() {
    return <div>PDIR</div>
}
